import { createContext, useContext, useState } from "react";
import en from "../locales/en.json";

export const LANG_KEY = "relevo_lang";
const SUPPORTED = ["es", "en"];

export const getLang = () => {
  const stored = localStorage.getItem(LANG_KEY);
  if (SUPPORTED.includes(stored)) return stored;
  return (navigator.language || "es").toLowerCase().startsWith("en") ? "en" : "es";
};

let current = getLang();

/** Traduce un texto en español (clave) al idioma activo. Sin traducción → devuelve el español. */
export const t = (es, vars) => {
  let out = current === "en" ? en[es] ?? es : es;
  if (vars) Object.entries(vars).forEach(([k, v]) => { out = out.replaceAll(`{${k}}`, v); });
  return out;
};

const LanguageContext = createContext({ lang: current, setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(current);
  const setLang = (l) => {
    if (!SUPPORTED.includes(l) || l === current) return;
    current = l;
    localStorage.setItem(LANG_KEY, l);
    document.documentElement.lang = l;
    setLangState(l);
    window.location.reload();
  };
  document.documentElement.lang = lang;
  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
